export const faqExpanded = question => ({
  type: 'FAQ Expanded',
  data: {
    question,
  },
});
